package com.cs.ejobin.i18n

import androidx.compose.runtime.*

@Stable
class I18nState(lang: AppLanguage = AppLanguage.FR) {
    var language by mutableStateOf(lang)
        private set

    fun setLanguage(lang: AppLanguage) { language = lang }

    fun t(key: String): String {
        val map = Translations.forLang(language)
        return map[key] ?: Translations.forLang(AppLanguage.FR)[key] ?: key
    }
}

val LocalI18n = staticCompositionLocalOf<I18nState> { error("LocalI18n not provided") }

@Composable
fun ProvideI18n(i18nState: I18nState, content: @Composable () -> Unit) {
    CompositionLocalProvider(LocalI18n provides i18nState, content = content)
}

@Composable
fun t(key: String): String = LocalI18n.current.t(key)